import { Component, OnDestroy, Output, EventEmitter, inject } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { unsubscribe } from '@fcom/core/utils';
import { IconButtonTheme } from '@fcom/ui-components';

import { NavigationMenuService } from '../../../../services';

@Component({
  selector: 'fin-navigation-trigger',
  styleUrls: ['./navigation-trigger.component.scss'],
  templateUrl: './navigation-trigger.component.html',
  standalone: false,
})
export class NavigationTriggerComponent implements OnDestroy {
  private navigationMenuService = inject(NavigationMenuService);

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconButtonTheme = IconButtonTheme;

  isNavigationMenuOpen$: Observable<boolean>;
  isOpen: boolean;

  @Output()
  toggleMenuGtmEvent: EventEmitter<Event> = new EventEmitter<Event>();
  private subscription: Subscription = new Subscription();

  constructor() {
    this.isNavigationMenuOpen$ = this.navigationMenuService.isNavigationMenuOpen$;
    this.subscription.add(this.isNavigationMenuOpen$.subscribe((isOpen) => (this.isOpen = isOpen)));
  }

  toggleMenu(): void {
    this.navigationMenuService.toggleMenuOpen();
    this.toggleMenuGtmEvent.emit();
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscription);
  }
}
